import { Injectable } from '@angular/core';
import { UserSelectionsService } from '../services/user-selections/user-selections.service';

/**
 * Utilities
 */
@Injectable()
export class Utilities {

    /**
     * @ignore
     */
    constructor(private userSelectionService: UserSelectionsService) {
    }

    /**
     * @description Gives the breakpoints of screen sizes
     * @param size of screen
     * @returns screen size in pixels
     */
    deviceSizes(size: string) {
        if (size === 'medium') {
            return 768;
        }
        if (size === 'large') {
            return 1300;
        }
    }

    /**
     * @description Gives correct strings for onsite vs offsite
     * @returns string
     */
    startLocationAsString(type: string) {
        if (type === 'off') {
            return 'offSite';
        }
        if (type === 'on') {
            return 'onSite';
        }
    }

    offSitePayload() {
        if (
            (this.userSelectionService.get('startLocation') === this.startLocationAsString('off')) &&
            this.userSelectionService.get('pickupLocation')
        ) {
            return this.userSelectionService.get('pickupLocation');
        } else {
            return {};
        }
    }

    redirectToUrl(url: string){
        window.location.href = url;
    }

}
